import styled from "styled-components"

export const FormActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .form-error {
    color: red;
  }
`
